import type { BigFraction } from "@aprao/common/src/math/BigFraction.js";
import { wrapFraction } from "@aprao/common/src/math/wrapFraction.js";
import { makeAutoObservable } from "mobx";

import type { ShapeProfitShareLender } from "../../shapes/ShapeLender.js";
import {
  LenderBaseFacade,
  type LenderBaseFacadeProviders,
  type LenderFeeFacade,
} from "./LenderBaseFacade.js";

export class ProfitShareLenderFacade {
  readonly loanType = "profitShare";

  readonly _lenderBase: LenderBaseFacade;

  constructor(
    readonly $model: ShapeProfitShareLender,
    readonly _providers: LenderBaseFacadeProviders,
  ) {
    makeAutoObservable(this);

    this._lenderBase = new LenderBaseFacade(this.$model, _providers);
  }

  get name() {
    return this._lenderBase.name;
  }

  get facilitySize() {
    return this._lenderBase.facilitySize;
  }

  get fees() {
    return this._lenderBase.fees;
  }

  get profitShare() {
    return wrapFraction(this.$model.profitShare);
  }

  set name(name: string) {
    this._lenderBase.name = name;
  }

  set profitShare(profitShare: BigFraction | null) {
    this.$model.profitShare = profitShare?.toFraction() ?? null;
  }

  addFee() {
    this._lenderBase.addFee();
  }

  removeFee(fee: LenderFeeFacade) {
    this._lenderBase.removeFee(fee);
  }
}
